export default __webpack_public_path__ + "static/about-marker-cf6bdd8af333dd73eeb909a69c0eb3aa.jpg";